import { pageOf } from '@britania/teams-kit-core';
import { z } from 'zod';
export const ticketPersonSchema = z.strictObject({
    name: z.string().nullable(),
    email: z.string().nullable(),
});
export const ticketApproverSchema = ticketPersonSchema.extend({
    /**
     * Já registrou a aprovação no Softdesk e não recebe mais lembrete. Opcional
     * na entrada (vale `false`), para que um corpo de envio escrito à mão não
     * precise dele.
     */
    approved: z.boolean().default(false),
});
export const pendingApprovalTicketSchema = z.strictObject({
    /** Código interno do chamado no Softdesk. */
    id: z.int(),
    /** Número do chamado como os usuários o conhecem. */
    number: z.string(),
    title: z.string().nullable(),
    /** `null` quando o chamado não tem um usuário solicitante cadastrado. */
    requester: ticketPersonSchema.nullable(),
    /** Todos os designados, inclusive os que já aprovaram. */
    approvers: z.array(ticketApproverSchema),
});
export const pendingApprovalTicketsPageSchema = pageOf(pendingApprovalTicketSchema);
//# sourceMappingURL=pending-approval-tickets.contract.js.map